import { Injectable } from '@angular/core';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';
import {
  AssignDataRes,
  FWNamesResponse,
  AssignedListResponse,
  NamesToUpdateResponse,
  RequestedWishlistResponse,
  NotFoundListResponse,
} from '../interfaces/names-to-update.interface';
import {
  ApiResponse,
  SuccessResponse,
} from '../interfaces/api-response.interface';

@Injectable({
  providedIn: 'root',
})
export class NamesToUpdateService extends ApiService {
  public fetchPhilRecords(
    queryParamsObj: any
  ): Observable<NamesToUpdateResponse> {
    return this.get<NamesToUpdateResponse>(ROUTES.NAMES_TO_UPDATE, {
      params: queryParamsObj,
    });
  }
  public migrateData(reqBody: any): Observable<any> {
    return this.post<any>(ROUTES.FD_MIGRATE, {
      body: reqBody,
    });
  }
  public getFWNames(queryParamsObj: any): Observable<FWNamesResponse> {
    return this.get<FWNamesResponse>(ROUTES.FW_NAMES, {
      params: queryParamsObj,
    });
  }

  public assignDataToFW(
    paramsObj: any,
    bodyObj: any
  ): Observable<AssignDataRes> {
    return this.post<AssignDataRes>(ROUTES.ASSIGN_DATA, {
      params: paramsObj,
      body: bodyObj,
    });
  }

  public editDetails(memCode: string, bodyObj: any): Observable<AssignDataRes> {
    return this.patch<AssignDataRes>(
      this.replacePathInfo(ROUTES.EDIT_DETAILS, {
        memCode: memCode,
      }),
      {
        body: bodyObj,
      }
    );
  }

  public fetchAssignData(reqBody: any): Observable<AssignedListResponse> {
    return this.get<AssignedListResponse>(ROUTES.FIND_DETAILS, {
      params: reqBody,
    });
  }

  public fetchNotFound(paramsObj: any): Observable<NotFoundListResponse> {
    return this.get<NotFoundListResponse>(ROUTES.NOT_FOUND_MEMBER, {
      params: paramsObj,
    });
  }

  public fetchRequestedWishlists(): Observable<RequestedWishlistResponse> {
    return this.get<RequestedWishlistResponse>(ROUTES.REQUESTED_WISHLIST);
  }

  public notInitiatedOrOtherCountryMember(
    memberCode: string,
    bodyObj: any
  ): Observable<SuccessResponse> {
    return this.patch<SuccessResponse>(
      this.replacePathInfo(ROUTES.NON_INITIATED, {
        memberCode: memberCode,
      }),
      {
        body: bodyObj,
      }
    );
  }

  public addItemToWishlist(wishlistId: number, bodyObj: any): Observable<any> {
    return this.post<any>(
      this.replacePathInfo(ROUTES.ADD_ITEM_TO_WISHLIST, {
        wishlistId: wishlistId,
      }),
      {
        body: bodyObj,
      }
    );
  }

  public addWishlist(bodyObj: any): Observable<any> {
    return this.post<any>(ROUTES.ADD_TO_WISHLIST, {
      body: bodyObj,
    });
  }

  public transferWishlist(bodyObj: any): Observable<any> {
    return this.post<any>(ROUTES.TRANSFER_WISHLIST, {
      body: bodyObj,
    });
  }

  public updateSerialNo(memCode: number, bodyObj: any): Observable<any> {
    return this.patch<any>(
      this.replacePathInfo(ROUTES.UPDATE_SERIAL_NO, {
        memCode: memCode,
      }),
      {
        body: bodyObj,
      }
    );
  }

  public acceptWishlist(wishlistId: number, bodyObj: any): Observable<any> {
    return this.post<any>(
      this.replacePathInfo(ROUTES.ACCEPT_WISHLIST, {
        wishlistId: wishlistId,
      }),
      {
        body: bodyObj,
      }
    );
  }

  public rejectWishlist(wishlistId: number, bodyObj: any): Observable<any> {
    return this.post<any>(
      this.replacePathInfo(ROUTES.REJECT_WISHLIST, {
        wishlistId: wishlistId,
      }),
      {
        body: bodyObj,
      }
    );
  }

  public notFound(memberCode: number, bodyObj: any): Observable<any> {
    return this.patch<any>(
      this.replacePathInfo(ROUTES.NOT_FOUND, {
        memberCode: memberCode,
      }),
      {
        body: bodyObj,
      }
    );
  }

  public addToFavourites(bodyObj: any): Observable<ApiResponse> {
    return this.post<ApiResponse>(ROUTES.FIND_DETAILS_ADD_FAV, {
      body: bodyObj,
    });
  }
}
